module.exports = __webpack_public_path__ + "img/Millionaire-3.f291bc8d.gif";